import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@/hooks/redux';
// import { ThemeSwitcher } from '@/components/common/ThemeSwitcher';

export function AuthLayout() {
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="max-w-[1600px] w-full min-h-screen mx-auto grid grid-cols-1  items-center ">
      {/* <div className="hidden md:flex items-center justify-center bg-white md:order-2">
        <img src="/login/login-img.png" alt="Astro" className="max-w-[90%] h-auto" />
      </div> */}

      <div className="flex items-center justify-center px-6 sm:px-10 md:order-1">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h2 className="font-spectral text-4xl font-semibold text-[#035B95]">MeraAstro</h2>
            <p className="mt-2 text-sm text-muted-foreground">
              “Welcome Back to Your Cosmic Journey”
            </p>
          </div>

          <Outlet />
        </div>
      </div>
    </div>
  );
}
